// extracted by mini-css-extract-plugin
export var notFound = "_404-module--notFound--RZPnm";
export var notFound__bgr = "_404-module--notFound__bgr--21cXR";
export var notFound__row = "_404-module--notFound__row--3gJ4W";
export var notFound__row__inner = "_404-module--notFound__row__inner--31_AX";